import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="selfie-upload"
export default class extends Controller {
  static targets = ["input"]

  upload() {
    const file = this.inputTarget.files[0]
    if (!file) return

    const formData = new FormData()
    formData.append("photo", file)

    // If you want to imitate delete style with method override:
    // formData.append("_method", "post") // For uploads, "post" is fine. For update, use "patch".

    fetch(this.uploadUrl, {
      method: "POST", // Rails expects POST for create/upload
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: formData
    })
    .then(response => {
      if (!response.ok) throw new Error("Upload failed")
      return response.text()
    })
    .then(html => {
      // If server responds with Turbo Stream, it will auto-update DOM
      Turbo.renderStreamMessage(html)
    })
    .catch(err => console.error(err))
  }

  get uploadUrl() {
    return this.data.get("url")
  }
}
